import { SNOWPLOW_COLLECTION_ENDPOINTS } from '@montugroup/data-collection';
import { apiBaseUrl, getAppEnv } from '~/constants/env';
import { API_B2C_DEVELOPMENT_BASE_URL, API_B2C_PRODUCTION_BASE_URL, API_B2C_STAGING_BASE_URL } from './api';

const appEnv = getAppEnv();
const CSP_DIRECTIVES = {
  'default-src': ["'self'"],
  'script-src': ["'self'"],
  'style-src': [
    "'self'",
    /*
      There is currently no easy way to avoid this for MUI in a SPA application, it is a security risk, but it is a necessary for MUI to work. Normally, we would not allow unsafe-inline for style-src. And we would use a nonce generated on the server for the inline styles. But this is a SPA client-side rendered app, and we cannot use a nonce for inline styles with MUI since we don't have a backend/server for this app. We have to use unsafe-inline for now.

      To take advantage of this security risk, an attacker would have to be able to inject arbitrary code into the app, which is unlikely since we have a Content Security Policy in place. If an attacker can inject arbitrary code into the app, then they could do much worse than inject styles. And if an attacker can inject arbitrary code into the app, then we have much bigger problems than this.

      We should revisit this in the future if we can find a better solution. To make this more secure, we could use a hash for the inline styles, but MUI does not currently support this (as of 12/03/25). Or we could use a nonce, but we would need a backend/server to act as some kind of middleware to generate the nonce and inject it into the app.
    */
    "'unsafe-inline'"
  ],
  'img-src': ["'self'", 'data:'],
  'connect-src': [
    "'self'",
    // Warehouse API
    apiBaseUrl(),
    // B2C API
    appEnv === 'production'
      ? API_B2C_PRODUCTION_BASE_URL
      : appEnv === 'staging'
        ? API_B2C_STAGING_BASE_URL
        : API_B2C_DEVELOPMENT_BASE_URL,
    // Datadog
    'https://browser-intake-us3-datadoghq.com',
    'https://rum.browser-intake-us3-datadoghq.com',
    'https://logs.browser-intake-us3-datadoghq.com',
    // Snowplow
    SNOWPLOW_COLLECTION_ENDPOINTS.prod,
    SNOWPLOW_COLLECTION_ENDPOINTS.staging,
    'https://*.launchdarkly.com'
  ],
  // Set worker-src for datadog session replays
  'worker-src': ['self', 'blob:']
};
export { CSP_DIRECTIVES };
